/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __assign } from "tslib";
import * as React from "react";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";
export var Upload = React.forwardRef(function (props, ref) {
    var isLarge = props.size >= IconSize.LARGE;
    var pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = { transformOrigin: "center" };
    return (React.createElement(SVGIconContainer, __assign({ iconName: "upload", ref: ref }, props),
        React.createElement("path", { d: isLarge ? "M200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 310.4 310.4 400 200 400zM280 200C274.4000000000001 200 269.4000000000001 202.2 265.8 205.8L220 251.8V100C220 89 211 80 200 80S180 89 180 100V251.8L134.2 205.8C130.6 202.2 125.6 200 120 200C109 200 100 209 100 220C100 225.6 102.2 230.6 105.8 234.2L185.8 314.2000000000001C189.4 317.8 194.4 320 200 320S210.6 317.8 214.2 314.2L294.2000000000001 234.2C297.8 230.6 300 225.6 300 220C300 209 291 200 280 200z" : "M160 320C71.6 320 0 248.4 0 160S71.6 0 160 0S320 71.6 320 160S248.4 320 160 320zM220 160C214.4 160 209.4 162.2 205.8 165.8L180 191.8V80C180 69 171 60 160 60S140 69 140 80V191.8L114.2 165.8C110.6 162.2 105.6 160 100 160C89 160 80 169 80 180C80 185.6 82.2 190.6 85.8 194.2L145.8 254.2C149.4 257.8 154.4 260 160 260S170.6 257.8 174.2 254.2L234.2 194.2C237.8 190.6 240 185.6 240 180C240 169 231 160 220 160z", fillRule: "evenodd", transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"), style: style })));
});
Upload.defaultProps = {
    size: IconSize.STANDARD,
};
Upload.displayName = "Blueprint5.Icon.Upload";
export default Upload;
//# sourceMappingURL=upload.js.map